import styles from "./styles.module.scss";

interface ILayoutTable {
  children: any;
}

export default function LayoutHookTable({ children }: ILayoutTable) {
  return <div className={styles.container}>{children}</div>;
}
